import { render, staticRenderFns } from "./ToggleThirdParty.vue?vue&type=template&id=33d39a0a&lang=pug"
import script from "./ToggleThirdParty.vue?vue&type=script&lang=js"
export * from "./ToggleThirdParty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports